import queryString from 'query-string';
import React from 'react';
import { useHistory, useLocation, useRouteMatch } from 'react-router-dom';

/**
 * @param  {} {label
 * @param  {} queryParameterValue
 * @param  {} queryParameterKey
 * @param  {} defaultActiveLabel}
 */

const DokanItemLabelsByStatus = ({
    label,
    queryParameterValue,
    queryParameterKey,
    defaultActiveLabel,
}) => {
    // Get Current URL Path
    const { path } = useRouteMatch();
    const { search } = useLocation();
    const history = useHistory();
    function useQuery() {
        return new URLSearchParams(useLocation().search);
    }

    const query = useQuery();
    const isQueryParamExist = (qParamObj) => {
        const newURL = queryString.stringifyUrl({
            url: path + search,
            query: qParamObj,
        });
        history.push(newURL);
    };
    console.log(query.get(queryParameterKey));
    const isActive = query.get(queryParameterKey) || defaultActiveLabel;
    return (
        label.value !== 0 && (
            <>
                <button
                    className={`mr-35px focus:outline-none ${
                        isActive === queryParameterValue
                            ? 'border-b-3px border-blue-dodger pb-5px text-primary'
                            : 'text-primary text-secondary'
                    }`}
                    type="button"
                    onClick={() =>
                        isQueryParamExist({
                            [queryParameterKey]: queryParameterValue,
                            page: 1,
                        })
                    }
                >
                    <span className="text-base font-semibold capitalize">
                        {label.title} <span className="text-secondary">({label.value})</span>
                    </span>
                </button>
            </>
        )
    );
};

export default DokanItemLabelsByStatus;
